const {Component} = require("react");
const PropTypes = require("prop-types");
const hammer = require("app/util/hammer");
const screen = require("app/util/screen");

class Trigger extends Component {

	show() {
		if (screen.mobile()) {
			let classList = document.body.className.split(" ");
			let index = classList.indexOf("show-filter");

			if (index === -1) {
				classList.push("show-filter");
			}

			document.body.className = classList.join(" ");
		}
	}

	hide() {
		if (screen.mobile()) {
			let classList = document.body.className.split(" ");
			let index = classList.indexOf("show-filter");

			if (index > -1) {
				classList.splice(index, 1);
			}

			document.body.className = classList.join(" ");
		}
	}
}

class OpenTrigger extends Trigger {

	static get propTypes() {
		return {
			title: PropTypes.string
		};
	}

	static get defaultProps() {
		return {
			title: translate("Filter")
		};
	}

	_onClick = (e) => {
		e.preventDefault();
		this.show();
	};

	render() {
		return (
			<div className="filter-trigger open" onClick={this._onClick}>{this.props.title}</div>
		);
	}

}

class CloseTrigger extends Trigger {

	_onClick = (e) => {
		e.preventDefault();
		this.hide();
	};

	componentDidMount() {
		const filterBar = document.querySelector(".side-filter-bar");
		const handleClickAway = e => {
			if (filterBar.contains(e.target)) {
				return;
			}

			this.hide();
		};

		if (filterBar) {

			// Click outside
			document.body.addEventListener("click", e => handleClickAway(e))
			hammer(document.body).on("tap", e => handleClickAway(e));
		}
	}

	render() {
		return (
			<div className="filter-trigger close" onClick={this._onClick}>
				<div className="line-1"></div>
				<div className="line-2"></div>
			</div>
		);
	}

}

module.exports = {
	OpenTrigger,
	CloseTrigger
};
